<script setup lang="ts">
import { computed } from "vue";
import { formatAmount } from "../../../../../utils/helper-functions";
import ClientDetails from "../../../../components/ClientDetails.vue";
import CompanyDetails from "../../../../components/CompanyDetails.vue";
import CompanyLogo from "../../../../components/CompanyLogo.vue";
import CurrentStep from "../../../../steps/CurrentStep.vue";
import StepComponents from "../steps";
import { usePayStore } from "../store";

const payStore = usePayStore();

const backgroundColor = computed(() => {
  if (
    payStore.companyDetails?.light_css &&
    payStore.companyDetails?.brand_colour_main
  ) {
    return payStore.companyDetails?.brand_colour_main;
  }
  return "#ffffff";
});
</script>
<template>
  <div class="mobile-view" :style="{ backgroundColor }">
    <div>
      <CompanyLogo
        v-if="payStore.isInitialised"
        :companyDetails="payStore.companyDetails"
        class="company-logo"
      />
    </div>
    <div v-if="payStore.paymentDetails" data-testid="pay-request-details" class="pay-request-details" :class="{'light-css': payStore.companyDetails?.light_css}">
      <h3>Payment summary</h3>
      <p class="payment-due">Payment due today:</p>
      <h1 class="payment-amount">{{ formatAmount(payStore.paymentDetails?.amount, payStore.paymentDetails?.currency) }}</h1>
      <ClientDetails
        :clientName="`${payStore.paymentDetails?.first_name} ${payStore.paymentDetails?.last_name}`"
        :clientEmail="payStore.paymentDetails?.email"
        :matterReference="payStore.paymentDetails?.matter_reference"
        :matterReferenceLabel="payStore.companyPaymentSettings?.matter_reference_label"
        :invoiceNumber="payStore.paymentDetails?.invoice_reference"
        :invoiceNumberLabel="payStore.companyPaymentSettings?.invoice_reference_label"
        :customReference="payStore.paymentDetails?.custom_reference"
        :attachments="payStore.paymentDetails?.payment_documents"
        :customReferenceLabel="payStore.companyPaymentSettings?.custom_reference_label"
      />
    </div>
    <CurrentStep
      :isDesktop="payStore.isDesktop"
      :isInitialised="payStore.isInitialised"
      :clientRequestError="payStore.payRequestError"
      :clientRequestClosed="payStore.payRequestClosed"
      :clientRequestComplete="payStore.payRequestComplete"
      :currentStep="payStore.currentStep"
      :companyDetails="payStore.companyDetails"
      :stepComponents="StepComponents"
      :stepSubmitting="payStore.stepSubmitting"
      @step:complete="payStore.setCurrentStepComplete()"
      @step:back="payStore.stepBack()"
    />
    <div>
      <CompanyDetails
        class="company-details"
        :isInitialised="payStore.isInitialised"
        :clientRequestError="payStore.payRequestError"
        :isDesktop="payStore.isDesktop"
        :companyDetails="payStore.companyDetails"
        :showCookieLink="true"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.mobile-view {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100vh;
  width: 100%;
  box-sizing: border-box;
}
.company-logo {
  padding: $spacing-m $spacing-s $spacing-s;
}
.company-details {
  padding: $spacing-m $spacing-s $spacing-m $spacing-s;
}

.pay-request-details{
  padding: $spacing-s;
  color: $color-neutral-800;
}

.current-step {
  padding: $spacing-m;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
}

h1 {
  margin-top: $spacing-xs;
  margin-bottom: $spacing-s;
  @include typography-h1;
}

h2 {
  margin-top: 0;
  margin-bottom: $spacing-s;
  @include typography-h2;
}

h3 {
  @include typography-h3;
  color: $color-neutral-800;
}

p {
  @include typography-body-normal;
  a {
    color: $color-primary-600;
  }
}
.light-css, h3 {
  color: $color-neutral-0;
}
</style>
